"use client";

import type { TextColor } from "@homeinstead/schemas";

import { EventName } from "@homeinstead/shared";
import { submitCarePlusInquiry } from "~www/actions/submitCarePlusInquiry";
import {
  InquiryRedirectStatus,
  InquiryTwoStepForm,
  useInquiryLeadForm,
} from "~www/components/LeadForm/Inquiry";
import { CarePlusContactStep } from "./CarePlusContactStep";
import { CarePlusRecipientStep } from "./CarePlusRecipientStep";
import {
  carePlusInquiryFormSchema,
  getCarePlusInquiryDefaultFormValues,
} from "./carePlusInquiry.schema";
import { getCarePlusInquiryTrackingProperties } from "./get-care-plus-inquiry-tracking-properties";

const CARE_PLUS_THANK_YOU_PATH = "/care-plus-thank-you";

type CarePlusLeadFormProps = {
  className?: string;
  textColor?: TextColor;
};

function CarePlusLeadForm({ className, textColor }: CarePlusLeadFormProps) {
  const {
    handleFormSubmit,
    isPending,
    isRedirecting,
    methods,
    setStep,
    step,
    submitFormAction,
  } = useInquiryLeadForm({
    eventName: EventName.CARE_PLUS_INQUIRY_SUBMIT,
    getDefaultValues: getCarePlusInquiryDefaultFormValues,
    getTrackingProperties: getCarePlusInquiryTrackingProperties,
    schema: carePlusInquiryFormSchema,
    submitAction: submitCarePlusInquiry,
    thankYouPath: CARE_PLUS_THANK_YOU_PATH,
  });

  if (isRedirecting) {
    return (
      <div className={className}>
        <InquiryRedirectStatus textColor={textColor} />
      </div>
    );
  }

  return (
    <div className={className}>
      <InquiryTwoStepForm
        handleFormSubmit={handleFormSubmit}
        methods={methods}
        onBack={() => setStep(1)}
        step={step}
        step1={
          <CarePlusRecipientStep
            nextStep={() => setStep(2)}
            textColor={textColor}
          />
        }
        step2={
          <CarePlusContactStep isPending={isPending} textColor={textColor} />
        }
        submitFormAction={submitFormAction}
        textColor={textColor}
      />
    </div>
  );
}

export { CarePlusLeadForm };
